import Button from "@/components/Button";
import { cn } from "@/lib/utils";
import { ButtonStoryblok, CommonStoryblok } from "@/component-types-sb";

export default function Navigation({ commonData, className }: { commonData: CommonStoryblok, className?: string }) {
  return (
    <nav
      className={cn(
        `flex flex-col items-center gap-2 font-bold`,
        className
      )}
    >
      {commonData?.nav_pages?.map((button: ButtonStoryblok) => (
        <Button
          key={button._uid}
          className="text-white"
          blok={{ ...button, type: "link", variant: "link" }}
        />
      ))}
    </nav>
  );
}
